import { render } from "./WorldCitySearchWidget.vue?vue&type=template&id=0d8ba449&scoped=true"
import script from "./WorldCitySearchWidget.vue?vue&type=script&lang=js"
export * from "./WorldCitySearchWidget.vue?vue&type=script&lang=js"

import "./WorldCitySearchWidget.vue?vue&type=style&index=0&id=0d8ba449&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ba449"]])

export default __exports__